module.exports = __webpack_public_path__ + "static/media/react.a22ae3a3.svg";